module.exports = __webpack_public_path__ + "card.png?10f32fcdd52c628ef6a97a875a3ed368";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card.png
// module id = 198
// module chunks = 0